import {
  OrganizationVideo,
  OrganizationVideoSortKey,
  useOrganizationVideosQuery,
} from 'lib/api/organizationVideo/useOrganizationVideoQuery';
import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { OrganizationVideosTable } from '../organizationVideosModal/OrganizationVideosTable';
import { VideoSourceType, ISourceType } from './types';
import { PaginationConstants } from 'lib/const/PaginationConstants';
import { useOrganizationVideoFiltersQuery } from 'lib/api/organizationVideo/useOrganizationVideoFiltersQuery';

const Content = styled.div`
  padding-top: 32px;
`;

interface Props {
  selectOrganizationVideo?: (url: string, source: ISourceType) => void;
}

const DEFAULT_PAGE = 0;
const DEFAULT_SIZE = 10;

export const TabOrganizationVideos = ({ selectOrganizationVideo }: Props) => {
  const [filter, setFilter] = useState<{
    [key: string]: string[];
  }>({});

  // sorting
  const [sortKey, setSortKey] = useState<OrganizationVideoSortKey | null>(null);
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [searchTerm, setSearchTerm] = useState('');
  const [order, setOrder] = useState(PaginationConstants.ASCENDING);

  // queries
  const {
    data,
    isLoading: isLoadingVideos,
    isFetching: isFetchingVideos,
  } = useOrganizationVideosQuery(
    {
      limit: DEFAULT_SIZE,
      page,
      search: searchTerm,
      filter,
      ...(!!sortKey && !!order ? { sortKey, order } : {}),
    },
    true
  );
  const videos = data?.videos || [];
  const count = data?.count || 0;

  const {
    data: filterData,
    isLoading: isLoadingFilters,
    isFetching: isFetchingFilters,
  } = useOrganizationVideoFiltersQuery();
  const filters = filterData?.filters || [];

  const handleOnSelectVideo = (video: OrganizationVideo) => {
    const videoUrl = video?.videoUrl;
    if (videoUrl) {
      selectOrganizationVideo?.(videoUrl, {
        sourceType: VideoSourceType.ORGANIZATION_VIDEO,
        sourceId: video.organizationVideoId,
      });
    }
  };

  const handleFilterChange = (key: string, selectedOption: string[]) => {
    if (key === 'make') {
      setFilter(prevState => ({
        ...prevState,
        [key]: selectedOption,
        model: [],
      }));
      return;
    }
    setFilter(prevState => ({
      ...prevState,
      [key]: selectedOption,
    }));
  };

  const isPreparingData = isLoadingVideos || isLoadingFilters;

  return (
    <Content>
      <OrganizationVideosTable
        filters={filters}
        handleFilterChange={handleFilterChange}
        onSelectVideo={handleOnSelectVideo}
        showAddToCovideo={false}
        filter={filter}
        videos={videos}
        count={count}
        isPreparingData={isPreparingData}
        isFetchingFilters={isFetchingFilters}
        isFetchingVideos={isFetchingVideos}
        setSortKey={setSortKey}
        sortKey={sortKey}
        setPage={setPage}
        page={page}
        setSearchTerm={setSearchTerm}
        searchTerm={searchTerm}
        setOrder={setOrder}
        order={order}
      />
    </Content>
  );
};
